import Vue from 'vue';

import Plugin from '../client-vue';

export default ({ env }) => {
  const { environment } = env;
  Vue.use(Plugin, { environment });
};
